import type { WithContext, Blog } from "schema-dts";
import { EnvConfig } from "./env";

export const siteUrl = EnvConfig.siteUrl;
export const siteTitle = EnvConfig.siteName;
export const siteAuthor = "Струсь Татьяна";
export const siteDesc = EnvConfig.siteDesc;

const homeJsonLdJson: WithContext<Blog> = {
  "@type": "Blog",
  "@context": "https://schema.org",
  url: siteUrl,
  author: siteAuthor,
  description: siteDesc,
  name: siteTitle,
};
export const homeJsonLd = JSON.stringify(homeJsonLdJson);
